<template>
  <div class="pc_container">
    <!-- 搜索料号、名称 -->
    <PageHeader
      type="1"
      bgc="#ffffff"
      :hasBack="false"
      :searchValue.sync="searchValue"
      :searchPlaceholder="$t('pcClue.searchPlaceholder')"
      @get="get"
    ></PageHeader>
    <div class="pc_container_inner">
      <!-- <van-grid v-if="navList && navList.length > 0" class="grid-container">
        <van-grid-item
          @click="onJump(item)"
          v-for="(item, index) in navList"
          :key="index"
          :icon="item.imgUrl"
          :text="item.text"
          class="clickable"
        />
      </van-grid> -->
      <!-- 筛选条件 -->
      <div class="filter-container">
        <!-- 产品类型 -->
        <div class="filter-item">
          <!-- 产品类型： -->
          <span class="filter-label">{{ $t("pcClue.productType") }}</span>
          <div class="filter-options">
            <!-- 动态简中候选：由本文件选项的 i18nKey 选择，只翻译标签，不改变选项值 -->
            <!-- pcClue.all：全部 -->
            <!-- pcClue.brand.skHynix：海力士 -->
            <!-- pcClue.brand.samsung：三星 -->
            <!-- pcClue.brand.micron：美光 -->
            <!-- pcClue.brand.infineon：英飞凌 -->
            <!-- pcClue.brand.nxp：恩智浦 -->
            <!-- pcClue.brand.st：意法半导体 -->
            <!-- pcClue.brand.ti：德州仪器 -->
            <!-- pcClue.brand.espressif：乐鑫 -->
            <!-- pcClue.brand.gigaDevice：兆易创新 -->
            <!-- pcClue.brand.winbond：华邦 -->
            <!-- pcClue.brand.nanya：南亚 -->
            <!-- pcClue.brand.broadcom：博通 -->
            <!-- pcClue.brand.qualcomm：高通 -->
            <!-- pcClue.brand.mediatek：联发科 -->
            <!-- pcClue.hongKong：香港 -->
            <!-- pcClue.domestic：国内 -->
            <!-- pcClue.bondedArea：保税区 -->
            <!-- pcClue.other：其他 -->
            <!-- pcClue.originalManufacturer：原厂 -->
            <!-- pcClue.originalCarton：原箱 -->
            <!-- pcClue.genuine：原装 -->
            <!-- pcClue.originalPackage：原包 -->
            <!-- pcClue.originalLabel：原标 -->
            <!-- pcClue.wide：宽 -->
            <!-- pcClue.narrow：窄 -->
            <!-- pcClue.card：卡片 -->
            <!-- pcClue.list：列表 -->
            <span
              v-for="(option, index) in expandStatus.productType
                ? productTypes
                : productTypes.slice(0, 12)"
              :key="index"
              class="filter-option"
              :class="{ active: selectedProductType === option.value }"
              @click="selectedProductType = option.value"
            >
              {{ option.i18nKey ? $t(option.i18nKey) : option.label }}
            </span>
            <!-- 收起 -->
            <!-- 展开 -->
            <span
              v-if="showExpandButtons.productType"
              class="filter-expand"
              @click="toggleExpand('productType')"
            >
              {{
                $t(
                  expandStatus.productType
                    ? "pcClue.collapse"
                    : "pcClue.expand",
                )
              }}
            </span>
          </div>
        </div>

        <!-- 产品品牌 -->
        <div class="filter-item">
          <!-- 产品品牌： -->
          <span class="filter-label">{{ $t("pcClue.productBrand") }}</span>
          <div class="filter-options">
            <!-- 动态简中候选：由本文件选项的 i18nKey 选择，只翻译标签，不改变选项值 -->
            <!-- pcClue.all：全部 -->
            <!-- pcClue.brand.skHynix：海力士 -->
            <!-- pcClue.brand.samsung：三星 -->
            <!-- pcClue.brand.micron：美光 -->
            <!-- pcClue.brand.infineon：英飞凌 -->
            <!-- pcClue.brand.nxp：恩智浦 -->
            <!-- pcClue.brand.st：意法半导体 -->
            <!-- pcClue.brand.ti：德州仪器 -->
            <!-- pcClue.brand.espressif：乐鑫 -->
            <!-- pcClue.brand.gigaDevice：兆易创新 -->
            <!-- pcClue.brand.winbond：华邦 -->
            <!-- pcClue.brand.nanya：南亚 -->
            <!-- pcClue.brand.broadcom：博通 -->
            <!-- pcClue.brand.qualcomm：高通 -->
            <!-- pcClue.brand.mediatek：联发科 -->
            <!-- pcClue.hongKong：香港 -->
            <!-- pcClue.domestic：国内 -->
            <!-- pcClue.bondedArea：保税区 -->
            <!-- pcClue.other：其他 -->
            <!-- pcClue.originalManufacturer：原厂 -->
            <!-- pcClue.originalCarton：原箱 -->
            <!-- pcClue.genuine：原装 -->
            <!-- pcClue.originalPackage：原包 -->
            <!-- pcClue.originalLabel：原标 -->
            <!-- pcClue.wide：宽 -->
            <!-- pcClue.narrow：窄 -->
            <!-- pcClue.card：卡片 -->
            <!-- pcClue.list：列表 -->
            <span
              v-for="(option, index) in expandStatus.productBrand
                ? productBrands
                : productBrands.slice(0, 14)"
              :key="index"
              class="filter-option"
              :class="{ active: selectedProductBrand === option.value }"
              @click="selectedProductBrand = option.value"
            >
              {{ option.i18nKey ? $t(option.i18nKey) : option.label }}
            </span>
            <!-- 收起 -->
            <!-- 展开 -->
            <span
              v-if="showExpandButtons.productBrand"
              class="filter-expand"
              @click="toggleExpand('productBrand')"
            >
              {{
                $t(
                  expandStatus.productBrand
                    ? "pcClue.collapse"
                    : "pcClue.expand",
                )
              }}
            </span>
          </div>
        </div>

        <!-- 货所在地 -->
        <div class="filter-item">
          <!-- 货所在地： -->
          <span class="filter-label">{{
            $t("pcClue.goodsLocationLabel")
          }}</span>
          <div class="filter-options">
            <!-- 动态简中候选：由本文件选项的 i18nKey 选择，只翻译标签，不改变选项值 -->
            <!-- pcClue.all：全部 -->
            <!-- pcClue.brand.skHynix：海力士 -->
            <!-- pcClue.brand.samsung：三星 -->
            <!-- pcClue.brand.micron：美光 -->
            <!-- pcClue.brand.infineon：英飞凌 -->
            <!-- pcClue.brand.nxp：恩智浦 -->
            <!-- pcClue.brand.st：意法半导体 -->
            <!-- pcClue.brand.ti：德州仪器 -->
            <!-- pcClue.brand.espressif：乐鑫 -->
            <!-- pcClue.brand.gigaDevice：兆易创新 -->
            <!-- pcClue.brand.winbond：华邦 -->
            <!-- pcClue.brand.nanya：南亚 -->
            <!-- pcClue.brand.broadcom：博通 -->
            <!-- pcClue.brand.qualcomm：高通 -->
            <!-- pcClue.brand.mediatek：联发科 -->
            <!-- pcClue.hongKong：香港 -->
            <!-- pcClue.domestic：国内 -->
            <!-- pcClue.bondedArea：保税区 -->
            <!-- pcClue.other：其他 -->
            <!-- pcClue.originalManufacturer：原厂 -->
            <!-- pcClue.originalCarton：原箱 -->
            <!-- pcClue.genuine：原装 -->
            <!-- pcClue.originalPackage：原包 -->
            <!-- pcClue.originalLabel：原标 -->
            <!-- pcClue.wide：宽 -->
            <!-- pcClue.narrow：窄 -->
            <!-- pcClue.card：卡片 -->
            <!-- pcClue.list：列表 -->
            <span
              v-for="(option, index) in expandStatus.deliveryAddress
                ? deliveryAddresses
                : deliveryAddresses.slice(0, 12)"
              :key="index"
              class="filter-option"
              :class="{ active: selectedDeliveryAddress === option.value }"
              @click="selectedDeliveryAddress = option.value"
            >
              {{ option.i18nKey ? $t(option.i18nKey) : option.label }}
            </span>
            <!-- 收起 -->
            <!-- 展开 -->
            <span
              v-if="showExpandButtons.deliveryAddress"
              class="filter-expand"
              @click="toggleExpand('deliveryAddress')"
            >
              {{
                $t(
                  expandStatus.deliveryAddress
                    ? "pcClue.collapse"
                    : "pcClue.expand",
                )
              }}
            </span>
          </div>
        </div>

        <!-- 货物情况 -->
        <div class="filter-item">
          <!-- 货物情况： -->
          <span class="filter-label">{{ $t("pcClue.goodsCondition") }}</span>
          <div class="filter-options">
            <!-- 动态简中候选：由本文件选项的 i18nKey 选择，只翻译标签，不改变选项值 -->
            <!-- pcClue.all：全部 -->
            <!-- pcClue.brand.skHynix：海力士 -->
            <!-- pcClue.brand.samsung：三星 -->
            <!-- pcClue.brand.micron：美光 -->
            <!-- pcClue.brand.infineon：英飞凌 -->
            <!-- pcClue.brand.nxp：恩智浦 -->
            <!-- pcClue.brand.st：意法半导体 -->
            <!-- pcClue.brand.ti：德州仪器 -->
            <!-- pcClue.brand.espressif：乐鑫 -->
            <!-- pcClue.brand.gigaDevice：兆易创新 -->
            <!-- pcClue.brand.winbond：华邦 -->
            <!-- pcClue.brand.nanya：南亚 -->
            <!-- pcClue.brand.broadcom：博通 -->
            <!-- pcClue.brand.qualcomm：高通 -->
            <!-- pcClue.brand.mediatek：联发科 -->
            <!-- pcClue.hongKong：香港 -->
            <!-- pcClue.domestic：国内 -->
            <!-- pcClue.bondedArea：保税区 -->
            <!-- pcClue.other：其他 -->
            <!-- pcClue.originalManufacturer：原厂 -->
            <!-- pcClue.originalCarton：原箱 -->
            <!-- pcClue.genuine：原装 -->
            <!-- pcClue.originalPackage：原包 -->
            <!-- pcClue.originalLabel：原标 -->
            <!-- pcClue.wide：宽 -->
            <!-- pcClue.narrow：窄 -->
            <!-- pcClue.card：卡片 -->
            <!-- pcClue.list：列表 -->
            <span
              v-for="(option, index) in expandStatus.goodsStatus
                ? goodsStatus
                : goodsStatus.slice(0, 12)"
              :key="index"
              class="filter-option"
              :class="{ active: selectedGoodsStatus === option.value }"
              @click="selectedGoodsStatus = option.value"
            >
              {{ option.i18nKey ? $t(option.i18nKey) : option.label }}
            </span>
            <!-- 收起 -->
            <!-- 展开 -->
            <span
              v-if="showExpandButtons.goodsStatus"
              class="filter-expand"
              @click="toggleExpand('goodsStatus')"
            >
              {{
                $t(
                  expandStatus.goodsStatus
                    ? "pcClue.collapse"
                    : "pcClue.expand",
                )
              }}
            </span>
          </div>
        </div>
      </div>

      <!-- 标签切换 -->
      <div class="clue-tabs-container">
        <!-- 左侧按钮 -->
        <div class="clue-tabs-left">
          <!-- 供求发布 -->
          <el-button type="primary" @click="handlePublish"
            >+ {{ $t("pcClue.publish") }}</el-button
          >
          <div class="management-checkbox" :class="{ active: isManagement }">
            <!-- 管理 -->
            <el-checkbox
              v-model="isManagement"
              @change="handleManagementChange"
              >{{ $t("pcClue.manage") }}</el-checkbox
            >
          </div>
        </div>

        <!-- 中间标签 -->
        <div class="clue-tabs-center">
          <div
            v-for="(tab, index) in [
              $t('pcClue.all'),
              $t('pcClue.supply'),
              $t('pcClue.demand'),
            ]"
            :key="index"
            class="tab-item"
            :class="{ active: active === index }"
            @click="active = index"
          >
            {{ tab }}
            <el-tag
              :type="index === 1 ? 'success' : 'primary'"
              size="small"
              class="tab-count"
            >
              {{ tabCounts[index] }}
            </el-tag>
          </div>
        </div>

        <!-- 右侧视图切换 -->
        <div class="clue-tabs-right">
          <div class="view-mode-group">
            <div class="view-mode-container">
              <!-- 动态简中候选：由本文件选项的 i18nKey 选择，只翻译标签，不改变选项值 -->
              <!-- pcClue.all：全部 -->
              <!-- pcClue.brand.skHynix：海力士 -->
              <!-- pcClue.brand.samsung：三星 -->
              <!-- pcClue.brand.micron：美光 -->
              <!-- pcClue.brand.infineon：英飞凌 -->
              <!-- pcClue.brand.nxp：恩智浦 -->
              <!-- pcClue.brand.st：意法半导体 -->
              <!-- pcClue.brand.ti：德州仪器 -->
              <!-- pcClue.brand.espressif：乐鑫 -->
              <!-- pcClue.brand.gigaDevice：兆易创新 -->
              <!-- pcClue.brand.winbond：华邦 -->
              <!-- pcClue.brand.nanya：南亚 -->
              <!-- pcClue.brand.broadcom：博通 -->
              <!-- pcClue.brand.qualcomm：高通 -->
              <!-- pcClue.brand.mediatek：联发科 -->
              <!-- pcClue.hongKong：香港 -->
              <!-- pcClue.domestic：国内 -->
              <!-- pcClue.bondedArea：保税区 -->
              <!-- pcClue.other：其他 -->
              <!-- pcClue.originalManufacturer：原厂 -->
              <!-- pcClue.originalCarton：原箱 -->
              <!-- pcClue.genuine：原装 -->
              <!-- pcClue.originalPackage：原包 -->
              <!-- pcClue.originalLabel：原标 -->
              <!-- pcClue.wide：宽 -->
              <!-- pcClue.narrow：窄 -->
              <!-- pcClue.card：卡片 -->
              <!-- pcClue.list：列表 -->
              <div
                v-for="mode in viewModes"
                :key="mode.value"
                class="view-mode-item"
                :class="{ active: viewMode === mode.value }"
                @click="viewMode = mode.value"
              >
                {{ $t(mode.i18nKey) }}
              </div>
            </div>
            <div class="view-mode-container">
              <!-- 动态简中候选：由本文件选项的 i18nKey 选择，只翻译标签，不改变选项值 -->
              <!-- pcClue.all：全部 -->
              <!-- pcClue.brand.skHynix：海力士 -->
              <!-- pcClue.brand.samsung：三星 -->
              <!-- pcClue.brand.micron：美光 -->
              <!-- pcClue.brand.infineon：英飞凌 -->
              <!-- pcClue.brand.nxp：恩智浦 -->
              <!-- pcClue.brand.st：意法半导体 -->
              <!-- pcClue.brand.ti：德州仪器 -->
              <!-- pcClue.brand.espressif：乐鑫 -->
              <!-- pcClue.brand.gigaDevice：兆易创新 -->
              <!-- pcClue.brand.winbond：华邦 -->
              <!-- pcClue.brand.nanya：南亚 -->
              <!-- pcClue.brand.broadcom：博通 -->
              <!-- pcClue.brand.qualcomm：高通 -->
              <!-- pcClue.brand.mediatek：联发科 -->
              <!-- pcClue.hongKong：香港 -->
              <!-- pcClue.domestic：国内 -->
              <!-- pcClue.bondedArea：保税区 -->
              <!-- pcClue.other：其他 -->
              <!-- pcClue.originalManufacturer：原厂 -->
              <!-- pcClue.originalCarton：原箱 -->
              <!-- pcClue.genuine：原装 -->
              <!-- pcClue.originalPackage：原包 -->
              <!-- pcClue.originalLabel：原标 -->
              <!-- pcClue.wide：宽 -->
              <!-- pcClue.narrow：窄 -->
              <!-- pcClue.card：卡片 -->
              <!-- pcClue.list：列表 -->
              <div
                v-for="type in viewTypes"
                :key="type.value"
                class="view-mode-item"
                :class="{ active: viewType === type.value }"
                @click="viewType = type.value"
              >
                {{ $t(type.i18nKey) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 我们是有底线的 -->
      <!-- 获取数据失败，请重新加载 -->
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('pcClue.endOfList')"
        :error-text="$t('pcClue.loadFailed')"
        @load="loadMoreInfo"
        style="max-height: none"
      >
        <!-- 列表视图 -->
        <el-table
          v-if="viewType === 'list'"
          :data="list"
          style="width: 100%; cursor: pointer"
          @row-click="handleRowClick"
        >
          <el-table-column width="30" v-if="isManagement">
            <template #default="{ row }">
              <div @click.stop>
                <el-checkbox
                  v-model="row.selected"
                  @change="handleCustomSelect(row)"
                ></el-checkbox>
              </div>
            </template>
          </el-table-column>
          <!-- 类型 -->
          <el-table-column :label="$t('pcClue.type')" min-width="65">
            <template #default="{ row }">
              <el-tag
                :type="row.clueType === 1 ? 'success' : 'primary'"
                size="small"
              >
                {{ $t(row.clueType === 1 ? "pcClue.supply" : "pcClue.buy") }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- 料号 -->
          <el-table-column
            prop="partNumber"
            :label="$t('pcClue.partNumber')"
            min-width="180"
          />
          <!-- 品牌 -->
          <el-table-column :label="$t('pcClue.brand')" min-width="70">
            <template #default="{ row }">
              <span style="color: #4a90e2">{{ row.goodsBrand || $t("auth.sentenceSeparator") }}</span>
            </template>
          </el-table-column>
          <!-- 分类 -->
          <el-table-column
            prop="productType"
            :label="$t('pcClue.category')"
            min-width="70"
          />
          <!-- 所在地 -->
          <el-table-column
            prop="deliveryAddress"
            :label="$t('pcClue.location')"
            min-width="60"
          />
          <!-- 货币 -->
          <el-table-column :label="$t('pcClue.currency')" min-width="60">
            <template #default="{ row }">
              {{ $t(row.priceUnit === 10 ? "pcClue.usd" : "pcClue.cny") }}
            </template>
          </el-table-column>
          <!-- 价格 -->
          <el-table-column
            prop="price"
            :label="$t('pcClue.price')"
            min-width="100"
          >
            <template #default="{ row }">
              <span style="color: #d4a056; font-weight: 500">
                {{ row.priceUnit === 10 ? "¥" : "$" }}{{ $formatPrice(row.price) }}/{{
                  row.goodsUnit
                }}
              </span>
            </template>
          </el-table-column>
          <!-- 数量 -->
          <el-table-column
            prop="goodsQuantity"
            :label="$t('pcClue.quantity')"
            min-width="70"
          />
          <!-- 批次 -->
          <el-table-column
            prop="manufactureDate"
            :label="$t('pcClue.batch')"
            min-width="60"
          />
          <!-- 货态 -->
          <el-table-column
            prop="manufactureDate"
            :label="$t('pcClue.condition')"
            min-width="70"
          >
            <template #default="{ row }">
              <el-tag type="warning" v-if="row.qk">{{
                $t("pcClue.originalManufacturer")
              }}</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <!-- 交货时间 -->
          <el-table-column
            prop="manufactureDate"
            :label="$t('pcClue.deliveryTime')"
            min-width="70"
          >
            <template #default="{ row }">
              {{
                row.deliveryPeriod
                  ? $t("pcClue.days", { count: row.deliveryPeriod })
                  : $t("pcClue.undetermined")
              }}
            </template>
          </el-table-column>
          <!-- 发布时间 -->
          <el-table-column
            prop="createTime"
            :label="$t('pcClue.publishedAt')"
            min-width="70"
          >
            <template #default="{ row }">
              {{ formatClueDate(row.createTime) }}
            </template>
          </el-table-column>
          <!-- 发布人 -->
          <el-table-column
            prop="supplierName"
            :label="$t('pcClue.publisher')"
            min-width="120"
          />
          <el-table-column width="30">
            <template #default="{ row }">
              <div class="arrow-icon">
                <i class="el-icon-arrow-right"></i>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 卡片视图 -->
        <div v-else-if="viewType === 'card'" class="card-container">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="card-item"
            :class="{ selected: item.selected }"
            @click="handleRowClick(item)"
          >
            <div class="card-header">
              <div v-if="isManagement" class="card-checkbox" @click.stop>
                <el-checkbox
                  v-model="item.selected"
                  @change="handleCustomSelect(item)"
                ></el-checkbox>
              </div>
              <!-- 供应 -->
              <!-- 求购 -->
              <el-tag
                :type="item.clueType === 1 ? 'success' : 'primary'"
                size="small"
              >
                {{ $t(item.clueType === 1 ? "pcClue.supply" : "pcClue.buy") }}
              </el-tag>
              <!-- 全新 -->
              <el-tag size="small" type="info">{{
                $t("pcClue.brandNew")
              }}</el-tag>
              <span class="card-no">No.{{ item.id || index + 1 }}</span>
            </div>
            <div class="card-content">
              <h3 class="card-title">{{ item.partNumber }}</h3>
              <div class="card-info">
                <el-tag size="small">{{ item.goodsBrand }}</el-tag>
                <el-tag size="small" type="info">{{ item.productType }}</el-tag>
              </div>
              <div class="card-price">
                {{ item.priceUnit === 10 ? "¥" : "$" }}{{ $formatPrice(item.price) }}/{{
                  item.goodsUnit
                }}
              </div>
              <div class="card-details">
                <div class="detail-item">
                  <!-- 库存 -->
                  <!-- 需求量 -->
                  <span class="detail-label"
                    >{{
                      $t(
                        item.clueType === 1
                          ? "pcClue.stock"
                          : "pcClue.demandQuantity",
                      )
                    }}:</span
                  >
                  <span class="detail-value">{{ item.goodsQuantity }}</span>
                </div>
                <div class="detail-item">
                  <!-- 起订 -->
                  <!-- 保证金 -->
                  <span class="detail-label"
                    >{{
                      $t(
                        item.clueType === 1
                          ? "pcClue.minimumOrder"
                          : "pcClue.deposit",
                      )
                    }}:</span
                  >
                  <span class="detail-value">{{
                    item.clueType === 1 ? "≥50" : "¥7,097"
                  }}</span>
                </div>
              </div>
              <div class="card-details">
                <div class="detail-item">
                  <!-- 地区 -->
                  <!-- 截标 -->
                  <span class="detail-label"
                    >{{
                      $t(
                        item.clueType === 1
                          ? "pcClue.region"
                          : "pcClue.bidDeadline",
                      )
                    }}:</span
                  >
                  <span class="detail-value">{{
                    item.clueType === 1
                      ? item.deliveryAddress
                      : "2026-03-25 18:00"
                  }}</span>
                </div>
                <div class="detail-item">
                  <!-- 批次 -->
                  <!-- 开标 -->
                  <span class="detail-label"
                    >{{
                      $t(
                        item.clueType === 1
                          ? "pcClue.batch"
                          : "pcClue.bidOpening",
                      )
                    }}:</span
                  >
                  <span class="detail-value">{{
                    item.clueType === 1
                      ? item.manufactureDate
                      : "2026-03-26 14:00"
                  }}</span>
                </div>
              </div>
              <div class="card-footer">
                <span class="card-date">{{
                  formatClueDate(item.createTime)
                }}</span>
                <!-- 5家 -->
                <span v-if="item.clueType === 2" class="card-count">{{
                  $t("pcClue.fiveSuppliers")
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-list>

      <!-- 选中项操作弹窗 -->
      <div
        v-if="selectedInfoItems.length > 0"
        style="
          position: fixed;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          background: #fff;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          padding: 15px 20px;
          box-shadow: 0 2px 15px rgba(0, 0, 0, 0.15);
          z-index: 1000;
          display: flex;
          justify-content: space-between;
          align-items: center;
          min-width: 300px;
          max-width: 400px;
          width: 60%;
        "
      >
        <!-- 已选择 {count} 项 -->
        <div>
          {{ $t("pcClue.selectedCount", { count: selectedInfoItems.length }) }}
        </div>
        <div>
          <!-- 删除 -->
          <el-button
            type="danger"
            size="medium"
            style="margin-right: 10px"
            @click="handleDeleteSelected"
            >{{ $t("pcClue.delete") }}</el-button
          >
          <!-- 审核 -->
          <el-button
            v-if="isAudit"
            type="success"
            size="medium"
            @click="handleAuditSelected"
            >{{ $t("pcClue.review") }}</el-button
          >
        </div>
      </div>
    </div>
    <PcFooter />
  </div>
</template>

<script>
/**
 * 名称：供求
 * 日期：2025-04-22 09:08:09
 * 作者：bd
 */
import { getNavList } from "@/api/index";
import { listGoods } from "@/api/goods";
import { getHomeClue } from "@/api/home";
import GoodsItem from "@/components/pc/GoodsItem.vue";
import PageHeader from "@/components/pc/PageHeader.vue";
import PcFooter from "@/components/pc/PcFooter.vue";
import { mapState } from "vuex";
export default {
  components: { GoodsItem, PageHeader, PcFooter },
  props: {},
  data() {
    return {
      searchValue: "",
      active: 0,
      // 标签列表
      tabs: ["货源", "求购"],
      // 当前选中的标签索引，默认选中第一个
      list: [],
      serachShow: false, //搜索查询状态刷新状态
      checkMore: true,
      refreshing: false, //刷新状态默认值
      loading: false,
      finished: false,
      isLoading: false,
      // 选中的信息列表项
      selectedInfoItems: [],
      // 筛选条件相关
      productTypes: [
        { label: "全部", value: "", i18nKey: "pcClue.all" },
        { label: "DDR3", value: "DDR3" },
        { label: "DDR4", value: "DDR4" },
        { label: "DDR5", value: "DDR5" },
        { label: "GDDR6", value: "GDDR6" },
        { label: "GDDR6X", value: "GDDR6X" },
        { label: "LPDDR3", value: "LPDDR3" },
        { label: "LPDDR4", value: "LPDDR4" },
        { label: "LPDDR4X", value: "LPDDR4X" },
        { label: "LPDDR5", value: "LPDDR5" },
        { label: "LPDDR5X", value: "LPDDR5X" },
        { label: "EMMC", value: "EMMC" },
        { label: "EMCP", value: "EMCP" },
        { label: "UFS", value: "UFS" },
        { label: "UFS3.1", value: "UFS3.1" },
        { label: "MCU", value: "MCU" },
      ],
      productBrands: [
        { label: "全部", value: "", i18nKey: "pcClue.all" },
        { label: "海力士", value: "海力士", i18nKey: "pcClue.brand.skHynix" },
        { label: "三星", value: "三星", i18nKey: "pcClue.brand.samsung" },
        { label: "美光", value: "美光", i18nKey: "pcClue.brand.micron" },
        { label: "英飞凌", value: "英飞凌", i18nKey: "pcClue.brand.infineon" },
        { label: "恩智浦", value: "恩智浦", i18nKey: "pcClue.brand.nxp" },
        {
          label: "意法半导体",
          value: "意法半导体",
          i18nKey: "pcClue.brand.st",
        },
        { label: "德州仪器", value: "德州仪器", i18nKey: "pcClue.brand.ti" },
        { label: "乐鑫", value: "乐鑫", i18nKey: "pcClue.brand.espressif" },
        {
          label: "兆易创新",
          value: "兆易创新",
          i18nKey: "pcClue.brand.gigaDevice",
        },
        { label: "华邦", value: "华邦", i18nKey: "pcClue.brand.winbond" },
        { label: "南亚", value: "南亚", i18nKey: "pcClue.brand.nanya" },
        { label: "博通", value: "博通", i18nKey: "pcClue.brand.broadcom" },
        { label: "高通", value: "高通", i18nKey: "pcClue.brand.qualcomm" },
        { label: "联发科", value: "联发科", i18nKey: "pcClue.brand.mediatek" },
      ],
      deliveryAddresses: [
        { label: "全部", value: "", i18nKey: "pcClue.all" },
        { label: "香港", value: "香港", i18nKey: "pcClue.hongKong" },
        { label: "国内", value: "国内", i18nKey: "pcClue.domestic" },
        { label: "保税区", value: "保税区", i18nKey: "pcClue.bondedArea" },
        { label: "其他", value: "其他", i18nKey: "pcClue.other" },
      ],
      goodsStatus: [
        { label: "全部", value: "", i18nKey: "pcClue.all" },
        {
          label: "原厂",
          value: "原厂",
          i18nKey: "pcClue.originalManufacturer",
        },
        { label: "原箱", value: "原箱", i18nKey: "pcClue.originalCarton" },
        { label: "原装", value: "原装", i18nKey: "pcClue.genuine" },
        { label: "原包", value: "原包", i18nKey: "pcClue.originalPackage" },
        { label: "原标", value: "原标", i18nKey: "pcClue.originalLabel" },
      ],
      // 选中的筛选条件
      selectedProductType: "",
      selectedProductBrand: "",
      selectedDeliveryAddress: "",
      selectedGoodsStatus: "",
      // 展开状态
      expandStatus: {
        productType: false,
        productBrand: false,
        deliveryAddress: false,
        goodsStatus: false,
      },
      // 标签切换相关
      isManagement: false,
      viewMode: "narrow", // 默认选中窄
      viewType: "list", // 默认选中列表
      tabCounts: [], // 全部、供应、需求的计数
      viewModes: [
        { label: "宽", value: "wide", i18nKey: "pcClue.wide" },
        { label: "窄", value: "narrow", i18nKey: "pcClue.narrow" },
      ],
      viewTypes: [
        { label: "卡片", value: "card", i18nKey: "pcClue.card" },
        { label: "列表", value: "list", i18nKey: "pcClue.list" },
      ],
      // 选中项
      selectedInfoItems: [],
      isAudit: true,
      params: {
        pageSize: 10,
        pageNum: 1,
        status: null,
        type: 1, //类型1货源2求购
      },
      navList: [],
      navParams: {
        which: 2,
        position: "CLUE_SOURCE",
        status: 0,
      },
      isFixed: false,
      infoFilters: {
        brand: "",
        model: "",
        type: "",
        supplier: "",
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  watch: {
    active(val) {
      this.supeActive();
      // this.onLoad();
      this.queryNav();
      this.params.pageNum = 1;
      this.infoFilters.pageNum = 1;
      this.finished = false;
      this.serachShow = true;
      this.queryList();
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userDetails,
    }),
    searchBoxClass() {
      return {
        fixed: this.isFixed,
      };
    },
    // 计算是否需要显示展开/收起按钮
    showExpandButtons() {
      return {
        productType: this.productTypes.length > 12,
        productBrand: this.productBrands.length > 12,
        deliveryAddress: this.deliveryAddresses.length > 12,
        goodsStatus: this.goodsStatus.length > 12,
      };
    },
  },
  methods: {
    formatClueDate(value) {
      if (!value) return "";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "";
      const month = date.getMonth() + 1;
      const day = date.getDate();
      // {month}月{day}日
      return this.$t("pcClue.monthDay", { month, day });
    },
    get(value) {
      console.log("搜索", value);
    },
    onJump(item) {
      if (item.type == "1") {
        this.$router.push({ path: "/goods/detail", query: { id: item.id } });
      } else if (item.type == "2") {
        this.$router.push({ path: "/goods/detail", query: { id: item.id } });
      }
    },
    // 处理商品搜索（子组件触发的事件）
    onProductSearch(value) {
      console.log("父组件接收商品搜索值：", value);
      // 这里写商品搜索的业务逻辑
      // 例如：调用接口 this.$api.searchProduct(value)
    },
    queryRoute() {
      let query = this.$route.query;
      if (query) {
        this.active = query.active ? JSON.parse(query.active) : 0;
        this.supeActive();
      }
    },
    queryNav() {
      getNavList(this.navParams).then((res) => {
        if (res.code == 200 && res.data) {
          this.navList = res.data ?? [];
        }
      });
    },
    supeActive() {
      if (this.active == 0) {
        this.params.type = 1;
        this.navParams.position = "CLUE_SOURCE";
      }
      if (this.active == 1) {
        this.params.type = 2;
        this.navParams.position = "CLUE_BUY";
      }
    },
    //页面加载
    onLoad() {
      this.isLoading = false;
      // 重置分页参数
      this.infoFilters.pageNum = 1;
      this.finished = false;
      // 模拟更新数据
      if (this.checkMore) {
        this.loading = true;
        // 如果有新数据
        setTimeout(() => {
          this.queryList(false);
        }, 300);
      } else {
        // 如果没有新数据
        this.finished = true;
      }
    },
    queryList(isLoadMore = false) {
      getHomeClue(this.infoFilters).then((res) => {
        this.loading = false;
        if (res.code == 200 && res.rows) {
          // 处理接口返回的数据，确保字段名正确
          const processedData = (res.rows || []).map((item) => {
            return {
              id: item.id || item.clueId || "",
              clueType: item.clueType || "",
              partNumber: item.partNumber || "",
              goodsBrand: item.goodsBrand || "",
              productType: item.productType || "",
              capacity: item.capacity || "",
              architecture: item.architecture || "",
              speed: item.speed || "",
              ball: item.ball || "",
              price: item.goodsPrice || "",
              goodsUnit: item.goodsUnit || "",
              goodsQuantity: item.goodsQuantity || "",
              manufactureDate: item.manufactureDate || "",
              deliveryAddress: item.deliveryAddress || "",
              supplierName: item.supplierName || "",
              supplierId: item.supplierId || "",
              selected: false,
              priceUnit: item.goodsPriceUnit || "",
              createTime: item.createTime || "",
            };
          });
          if (isLoadMore) {
            this.list = this.list.concat(processedData);
          } else {
            this.list = processedData;
          }
          // 判断是否还有更多数据
          if (processedData.length < this.infoFilters.pageSize) {
            this.finished = true;
          } else {
            this.finished = false;
            this.infoFilters.pageNum += 1;
          }
          this.tabCounts = [res.total, res.total, 0];
        } else {
          if (!isLoadMore) {
            this.list = [];
          }
          this.finished = true;
        }
      });
    },
    isLogin() {
      return this.$store.getters.token;
    },
    onJump(item) {
      if (item.path) {
        this.$router.push(item.path);
      } else {
        this.$router.push("/myxg/myDetails?id=" + item.id + "&source=order");
      }
    },
    // 处理表格行点击事件
    handleRowClick(row) {
      if (this.isManagement) {
        // 管理模式下切换行的选中状态
        row.selected = !row.selected;
        this.handleCustomSelect(row);
      } else {
        // 非管理模式下跳转到货源详情页面，带着id
        this.$router.push({
          path: "/clue/clueDetail",
          query: { id: row.id },
        });
      }
    },
    // 处理信息列表项选择
    handleCustomSelect(row) {
      if (row.selected) {
        // Add to selected items
        this.selectedInfoItems.push(row);
      } else {
        // Remove from selected items
        this.selectedInfoItems = this.selectedInfoItems.filter(
          (item) => item.id !== row.id,
        );
      }
    },
    // 加载更多信息
    loadMoreInfo() {
      if (this.finished) return;
      this.loading = true;
      setTimeout(() => {
        this.queryList(true);
      }, 2500);
    },
    // 切换展开/收起状态
    toggleExpand(type) {
      this.expandStatus[type] = !this.expandStatus[type];
    },
    // 处理供求发布
    handlePublish() {
      // 跳转到供求发布页面
      this.$router.push("/publish");
    },
    // 处理自定义选择
    handleCustomSelect(row) {
      if (row.selected) {
        this.selectedInfoItems.push(row);
      } else {
        const index = this.selectedInfoItems.findIndex(
          (item) => item.id === row.id,
        );
        if (index > -1) {
          this.selectedInfoItems.splice(index, 1);
        }
      }
    },
    // 处理删除选中项
    handleDeleteSelected() {
      // 这里可以添加删除逻辑
      console.log("删除选中项", this.selectedInfoItems);
      this.selectedInfoItems = [];
    },
    // 处理审核选中项
    handleAuditSelected() {
      // 这里可以添加审核逻辑
      console.log("审核选中项", this.selectedInfoItems);
    },
    // 处理管理模式切换
    handleManagementChange(val) {
      if (!val) {
        // 取消管理模式时清空选中项
        this.selectedInfoItems = [];
        // 重置列表项的选中状态
        this.list.forEach((item) => {
          item.selected = false;
        });
      }
    },
  },
  created() {
    this.queryRoute();
    this.onLoad();
    this.queryNav();
  },
};
</script>
<style lang="less" scoped>
.pc_container_inner {
  padding-top: 24px;
}
// 快捷入口
.grid-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-count: 4; /* 设置列数 */
  -webkit-column-count: 4; /* Safari 必须加前缀 */
  column-gap: 10px; /* 设置列之间的间隙 */
  -webkit-column-gap: 10px; /* Safari 必须加前缀 */
  height: 160px;
  margin-bottom: 72px;
  .van-grid-item {
    /deep/.van-grid-item__icon {
      font-size: 56px;
    }
    /deep/.van-grid-item__text {
      font-size: 20px;
    }
  }
}
// 筛选条件
.filter-container {
  margin-bottom: 24px;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: relative;

  .filter-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
    min-height: 32px;

    &:last-child {
      margin-bottom: 0;
    }

    .filter-label {
      font-weight: 500;
      margin-right: 16px;
      white-space: nowrap;
      font-size: 14px;
      color: #333333;
      width: 80px;
      padding-top: 4px;
    }

    .filter-options {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
      flex: 1;
      min-width: 0;
      padding-right: 60px; /* 为展开/收起按钮留出空间 */
      position: relative;

      .filter-option {
        padding: 4px 12px;
        border-radius: 16px;
        background: #f5f7fa;
        cursor: pointer;
        font-size: 14px;
        transition: all 0.3s ease;
        white-space: nowrap;

        &:hover {
          background: #e6f0ff;
        }

        &.active {
          background: #409eff;
          color: #ffffff;
        }
      }

      .filter-expand {
        color: #4286f5;
        cursor: pointer;
        font-size: 14px;
        white-space: nowrap;
        position: absolute;
        right: 0;
        top: 4px;
        background: #ffffff;
        padding: 4px 8px;
        border-radius: 16px;
      }
    }
  }
}

// 标签切换容器
.clue-tabs-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 12px 0;
  border-bottom: 1px solid #e0e0e0;

  // 左侧按钮
  .clue-tabs-left {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 0 0 auto;

    .el-button {
      border-radius: 4px;
    }

    .management-checkbox {
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      padding: 11px 10px;
      display: flex;
      align-items: center;
      min-width: 80px;
      background: #ffffff;
      transition: all 0.3s ease;

      &:hover {
        border-color: #409eff;
      }

      &.active {
        border-color: #409eff;
        background: #e6f0ff;
      }

      .el-checkbox {
        font-size: 14px;
        display: flex;
        align-items: center;

        .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: #409eff;
          border-color: #409eff;
        }

        .el-checkbox__inner {
          border-color: #000000;

          &:hover {
            border-color: #409eff;
          }
        }
      }
    }
  }

  // 中间标签
  .clue-tabs-center {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    justify-content: center;

    .tab-item {
      padding: 8px 20px;
      border-radius: 4px;
      background: #ffffff;
      border: 1px solid #e0e0e0;
      cursor: pointer;
      font-size: 16px;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      gap: 6px;
      min-width: 100px;
      justify-content: center;

      &:hover {
        border-color: #409eff;
      }

      &.active {
        background: #409eff;
        color: #ffffff;
        border-color: #409eff;
      }

      .tab-count {
        margin-left: 8px;
      }
    }
  }

  // 右侧视图切换
  .clue-tabs-right {
    display: flex;
    align-items: center;
    flex: 0 0 auto;

    .view-mode-group {
      display: flex;
      gap: 8px;

      .view-mode-container {
        display: flex;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        overflow: hidden;

        .view-mode-item {
          padding: 6px 14px;
          cursor: pointer;
          font-size: 14px;
          transition: all 0.3s ease;
          border-right: 1px solid #e0e0e0;

          &:last-child {
            border-right: none;
          }

          &:hover {
            background: #e6f0ff;
          }

          &.active {
            background: #409eff;
            color: #ffffff;
          }
        }
      }
    }
  }
}

// Element UI 表格样式覆盖
:deep(.el-table) {
  margin-top: 20px;

  .el-table__header-wrapper th {
    background-color: #f5f7fa;
    font-weight: 600;
  }

  .el-table__row:nth-child(even) {
    background-color: #fafafa;
  }

  .el-table__row:hover {
    background-color: #f0f9eb;
  }

  .arrow-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #909399;
    font-size: 14px;

    .el-icon-arrow-right {
      transition: all 0.3s ease;
    }
  }

  .el-table__row:hover .arrow-icon {
    color: #409eff;
  }
}

// 卡片视图样式
.card-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  padding: 20px 0;
}

.card-item {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
  }

  &.selected {
    background: #e6f0ff;
    border-color: #409eff;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  }

  .card-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 12px;
    flex-wrap: wrap;

    .card-checkbox {
      margin-right: 4px;
    }

    .card-no {
      margin-left: auto;
      font-size: 10px;
      color: #909399;
    }
  }

  .card-content {
    .card-title {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 8px;
      color: #303133;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .card-info {
      display: flex;
      gap: 6px;
      margin-bottom: 12px;
      flex-wrap: wrap;
    }

    .card-price {
      font-size: 16px;
      font-weight: 600;
      color: #d4a056;
      margin-bottom: 12px;
    }

    .card-details {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;

      .detail-item {
        display: flex;
        flex-direction: column;
        gap: 2px;

        .detail-label {
          font-size: 10px;
          color: #909399;
        }

        .detail-value {
          font-size: 12px;
          color: #303133;
          font-weight: 500;
        }
      }
    }

    .card-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 16px;
      padding-top: 12px;
      border-top: 1px solid #f0f0f0;

      .card-date {
        font-size: 10px;
        color: #909399;
      }

      .card-count {
        font-size: 10px;
        color: #409eff;
        display: flex;
        align-items: center;
        gap: 2px;

        &::before {
          content: "👥";
          font-size: 10px;
        }
      }
    }
  }
}
</style>
